<div class="mx-2 d-grid">
  <span class="me-1">{{ odometerModel.title }}</span>
  <span class="font-weight-bold">
    {{ odometerModel.value }} <span class="ms-1">{{ odometerModel.unit }}</span>
  </span>
</div>
